import { AlertService } from '../alert/alert.service';
import { SecService } from './sec.service';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DateModel } from 'ng2-datepicker';
import { DatePickerOptions } from 'ng2-datepicker';
import * as moment from 'moment';


/**
*  This class represents the lazy loaded LoginComponent.
*/

@Component({
  selector: 'app-sec-cmp',
  templateUrl: 'sec.component.html'
})

export class SecComponent implements OnInit {

  model: any = {};
  loading = false;
  returnUrl: string;
  pattern: string;
  socSec: SocSec;
  date: DateModel;
  options: DatePickerOptions;
  dateErrors: boolean;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private secService: SecService,
    private alertService: AlertService) {
    this.pattern = '[0-9]{8}';
    this.dateErrors = false;
    this.options = new DatePickerOptions({
      //      autoApply: false,
      format: 'YYYYMMDD',
      selectYearText: 'Välj år',
      todayText: 'I dag',
      clearText: 'Кlar',
      firstWeekdaySunday: false,
      locale: 'mk',
      maxDate: new Date(),
      initialDate: new Date(),
    });

  }

  ngOnInit() {
    this.socSec = new SocSec();
  }

  login() {
  }
  generate() {
    // validate the date of birth pattern
    let patt = new RegExp(this.pattern);
    let dateText = (this.date.year + '' + this.date.month + '' + this.date.day);
    if (this.date.formatted != dateText) {
      let fromNow = moment(this.date.formatted, 'YYYYMMDD').fromNow();
      if (new String(fromNow.toLowerCase()).startsWith('in')) {
        dateText = 'error';
        this.dateErrors = true;
      } else {
        dateText = this.date.formatted;
      }
    }
    if (patt.test(dateText) && dateText.length == 8) {

      this.loading = true;
      this.secService.generate(dateText, this.socSec.gender)
        .subscribe(
        data => {
          let cd = localStorage.getItem('currentCode');
          if (cd != null) {
            this.socSec.code = cd;
            this.used();
          }
          this.loading = false;
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
        });
    } else {
      this.dateErrors = true;
    }
    //    this.socSec.code = 'asd123';
  }
  used() {
    let index = localStorage.getItem('currentIndex');
    //    JSON.parse(this.socSec);
    let js =
      {
        "code": this.socSec.code,
        "dateOfBirth": this.date.formatted,
        "gender": this.socSec.gender + '',
        "index": new Number(index),
        "timestamp": Date.now()
      };
    this.loading = true;
    this.secService.store(js)
      .subscribe(
      data => {

        this.loading = false;
      },
      error => {
        this.alertService.error(error);
        this.loading = false;
      });
    //    this.reset();
  }
  reset() {
    this.socSec = new SocSec();
    this.dateErrors = false;
  }
  generated(): boolean {
    return this.socSec.code != null;
  }
  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    this.router.navigate(['/login?returnUrl=%2Fsec']);
  }
}

export class SocSec {

  dateOfBirth: string;
  gender: String;
  code: String;
  constructor() {
    this.gender = 'Unknown';
  }
}




// WEBPACK FOOTER //
// ./src/app/sec/sec.component.ts